import { ShapeMemoryConstraint } from '../model/vo/option';

/** 옵션값(공백 제거 후) '형상기억가공' 포함 여부 — grey-out 대상 항목 식별용 */
export const isCurtainShapeMemoryOption = (optArtiNm: string): boolean => {
  return optArtiNm.replace(/\s+/g, '').includes('형상기억가공');
};

/**
 * 형상기억가공 dropdown 하단에 노출할 제약 안내 문구를 해소한다.
 *
 * getDropdownListByPath 는 미선택 단계에 직전 선택 노드의 nextOptionList 를
 * 그대로 흘려보내므로, 형상기억가공 단계가 활성일 때 그 다음 단계 dropdown 의
 * items 에도 형상기억가공 옵션이 그대로 실려 온다. 따라서 items 만으로 판정하면
 * 다음 단계 dropdown 에까지 문구가 중복 노출된다.
 * → 단계 고유값인 placeholder(=titleNm) 로 실제 형상기억가공 dropdown 인지 가드한다.
 */
export const resolveShapeMemoryErrorMessage = ({
  placeholder,
  items,
  constraint,
}: {
  placeholder: string;
  items: { artiNm: string }[];
  constraint?: ShapeMemoryConstraint;
}): string | undefined => {
  const isShapeMemoryDropdown = isCurtainShapeMemoryOption(placeholder);
  const hasShapeMemoryItem = items.some((item) =>
    isCurtainShapeMemoryOption(item.artiNm),
  );

  return isShapeMemoryDropdown && hasShapeMemoryItem && constraint?.disabled
    ? constraint.message ?? undefined
    : undefined;
};

/** 장바구니/주문 차단 응답 코드 (BE 합의 — code 670) */
export const CURTAIN_SHAPE_MEMORY_BLOCK_CODE = 670;

/**
 * 차단(code 670) 응답 message(JSON 문자열)를 알럿 표시용으로 파싱한다.
 *
 * BE 계약: message = JSON.stringify({ title, subTitle })
 * - PC/모바일 알럿은 title + content(=subTitle) 구조로 노출
 * - 파싱 실패/형식 불일치 시 undefined 반환 → 호출부에서 apiResponse.message fallback
 */
export const parseShapeMemoryBlockedAlert = (
  message?: string,
): { title: string; content: string } | undefined => {
  if (!message) return undefined;
  try {
    const parsed = JSON.parse(message) as {
      title?: string;
      subTitle?: string;
    };
    if (!parsed || (!parsed.title && !parsed.subTitle)) return undefined;
    return {
      title: parsed.title ?? '',
      content: parsed.subTitle ?? '',
    };
  } catch {
    return undefined;
  }
};
